module.exports = fox._r("htmlplayer/fonts/acplayer.svg?9g9mys", __webpack_public_path__ + "_/_/_/_/common-components/htmlplayer/fonts/acplayer.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/htmlplayer/fonts/acplayer.svg?9g9mys
// module id = 565
// module chunks = 4